module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABDElEQVQ4T+WTIUuDURSGnzdtGBZEgzKGDpPZpgbZFk3bH9Bg8J8Mo8WyMBZdEFEsLhiswsBfoCBLgqBg0VeOfBufQ/2G2HbSvee+9zmX95wrfgnbJaAg6fYnmTIA58CqpOW/AnoJYGGaALZ3gBtJfdsjD2wXgQZwKOlt6MmXLtiO/SNgoAochInAGnAFLAFlSXffAiJpexO4AF6BJ2AOGAArwK6kdrojny+wvSjpYXhgews4A2aS3DuwJ6mV0swCL7JdAS6BDUnXKUENOAVywL6ko3Rl2/fx0gCEMcfAtqSoOgrb68C8pJPxQbL9nAnIGPP/A9SBbtK+cH7SiP/RDQ9i0QTyk95MdDErnQ8Tz3+UWT3zMAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_download.png
// module id = wqNP
// module chunks = 1